import React from 'react';
import Home from './Home';
import About from './About';
import Experience from './Experience';
import Projects from './Projects';
import Contact from './Contact';

const HomePage = () => {
  return (
    <>
      <Home />
      <About />
      <Experience />
      <Projects />
      <Contact />
    </>
  );
};

export default HomePage;
